// UI strings that are hardcoded in the main app, in either language:
// - English source -> Russian via i18n/tx.ru.json
// - Russian source -> English via i18n/tx.en.json + domains/i18n.en.json
//   (the Domains tr()/trf() are aliases of tx()/txf())
// The language follows the app-wide EN/RU switch (LangProvider calls
// setTxLang). Switching reloads the page, so values computed at import time
// pick up the new language too.
import RU from "../i18n/tx.ru.json";
import TX_EN from "../i18n/tx.en.json";
import DOMAINS_EN from "../domains/i18n.en.json";
import safeStorage from "./safeStorage";

// Russian sources: the Domains section (domains/i18n.en.json) and the main app.
const EN = { ...DOMAINS_EN, ...TX_EN };

let current = safeStorage.getItem("xpnsr_lang") === "ru" ? "ru" : "en";

export function getTxLang() {
  return current;
}

export function setTxLang(lang) {
  current = lang === "ru" ? "ru" : "en";
}

const has = (dict, s) => Object.prototype.hasOwnProperty.call(dict, s);

export function tx(s) {
  if (current === "ru") return has(RU, s) ? RU[s] : s;
  return has(EN, s) ? EN[s] : s;
}

export function txf(s, ...args) {
  return tx(s).replace(/\{(\d+)\}/g, (m, i) => (args[Number(i)] !== undefined ? String(args[Number(i)]) : m));
}
